import moment from 'moment';
import { humanise } from 'components/atoms/humanised-date';
import { useTranslate } from 'hooks/use-translation';
import { AllocationEvent } from '../../event-types';
import { ignoreMinutesIfZero } from '../../utils/dates';

export const allocationTooltip = (
  {
    startDate,
    endDate,
    totalMinutes,
    minutes,
  }: Pick<
    AllocationEvent,
    | 'startDate'
    | 'endDate'
    | 'projectPhase'
    | 'totalMinutes'
    | 'minutes'
    | 'billable'
  >,
  translate: ReturnType<typeof useTranslate>,
  isHoursPerWeek?: boolean,
): string =>
  `<div><span>${translate(
    'resource_management.allocation_event.tooltip.dates',
  )}:</span><strong> ${humanise(moment(startDate))} - ${humanise(
    moment(endDate),
  )}</strong> (${
    isHoursPerWeek
      ? translate(
          'resource_management.allocation_event.tooltip.number_of_weeks',
          { weeks: totalMinutes / minutes / 5 },
        )
      : translate(
          'resource_management.allocation_event.tooltip.number_of_days',
          { days: totalMinutes / minutes },
        )
  })</div>
  <div><span>${translate(
    'resource_management.allocation_event.tooltip.allocated',
  )}:</span><strong> ${ignoreMinutesIfZero(
    totalMinutes,
  )}</strong> (${ignoreMinutesIfZero(minutes * (isHoursPerWeek ? 5 : 1))}${
    isHoursPerWeek ? '/w' : '/d'
  })</div>`;
